/**
 * Site-wide business details. Keep name, address, and phone identical across
 * the site — search engines compare them against the Google Business Profile.
 */

export const SITE_URL = 'https://recreorehab.com'
export const BOOKING_URL = 'https://recreorehab.janeapp.com'

// Paste the public Google Business Profile link here (Share → Copy link).
// Components that use it render nothing while it is empty.
export const GOOGLE_PROFILE_URL = ''

export const business = {
  name: 'Recreo Rehab',
  tagline: 'Massage therapy, athletic therapy, and naturopathic care in Midtown Toronto.',
  street: '161 Eglinton Ave E, Unit 206',
  city: 'Toronto',
  region: 'ON',
  postalCode: 'M4P 1J5',
  entranceNote: 'Commercial entrance on Redpath Ave.',
  phoneDisplay: '(416) 826-2497',
  phoneHref: 'tel:+14168262497',
  email: 'info@recreorehab.com',
  instagram: 'https://instagram.com/recreorehab',
  mapUrl:
    'https://www.google.com/maps?q=161+Eglinton+Ave+E+Unit+206,+Toronto,+ON+M4P+1J5',
  mapEmbedUrl:
    'https://www.google.com/maps?q=161+Eglinton+Ave+E,+Toronto,+ON+M4P+1J5&output=embed',
}

export const hours = [
  { days: 'Monday — Friday', time: '8:30 am — 8:30 pm' },
  { days: 'Saturday', time: '8:30 am — 2:30 pm' },
  { days: 'Sunday', time: 'Closed' },
]
